module.exports = __webpack_public_path__ + "img/link.dd94206c.svg";